import React from "react";
import { Users, Briefcase, Layers } from "lucide-react";
import { SectionHeader } from "./_shared";

export default function Problem() {
  const cards = [
    { icon: Users, title: "For Investors", items: [
      "Too many unverified opportunities",
      "Numbers are not always source-backed",
      "Diligence is scattered across emails and folders",
      "Investor mandate matching is inefficient",
    ]},
    { icon: Briefcase, title: "For Startups", items: [
      "Hard to know if they are investor-ready",
      "Same documents are shared again and again",
      "Investor questions are unstructured",
      "No verified capital profile exists",
    ]},
    { icon: Layers, title: "For Deal Teams", items: [
      "Screening is manual",
      "Data verification takes time",
      "Red flags are not tracked systematically",
      "Follow-ups lack structure",
    ]},
  ];
  return (
    <section className="py-16 lg:py-20 bg-cream" data-testid="problem-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader
          eyebrow="THE GAP"
          title="Private market investing should not depend only on pitch decks."
          subtitle="Pitch decks are often self-declared. Investors still need company data, financial proof, documents, founder responses, red flags, and diligence material before they can take a serious view. VENTURAZ brings these layers into one controlled workflow."
        />
        <div className="grid md:grid-cols-3 gap-5">
          {cards.map(({ icon: Icon, title, items }) => (
            <div key={title} className="rounded-lg border border-navy/10 bg-white p-6 hover:border-gold/50 hover:shadow-lg transition-all" data-testid={`problem-card-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="w-9 h-9 rounded-md bg-gold/10 flex items-center justify-center mb-4">
                <Icon size={18} className="text-gold" />
              </div>
              <div className="font-heading text-lg text-ink">{title}</div>
              <ul className="mt-3 space-y-1.5 text-sm text-ink-soft">
                {items.map((it) => (
                  <li key={it} className="flex items-start gap-2">
                    <span className="mt-1 w-1 h-1 rounded-full bg-gold flex-shrink-0" />
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
